import debounce from 'lodash/debounce'

export default {

    loadingKey: 'loading',
    error: debounce(function(error){ this.onQueryError(error) }, 500)
};